class Collapsable extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
        this.openCollapsable();
    }

    btnEventListeners() {
        const { collapsable } = this.collapsableComponents();
        collapsable.forEach(item => {
            item.addEventListener('click', () => {
                this.toggleCollapsable(item);
            });
        })
    }

    openCollapsable() {
        const { openCollapsable } = this.collapsableComponents();
        openCollapsable.forEach(collapsable => {
            this.toggleCollapsable(collapsable, false);
        })
    }

    toggleCollapsable(item, scroll = true) {
        this.closeAllDropdowns();

        if(item.querySelector('.collapsable-description').classList.contains('hidden')) {
            item.querySelector('.collapsable-description').classList.remove('hidden');
            item.querySelector('.collapsable-arrow').classList.add('rotate-180');
            item.querySelector('.collapsable-title h4').classList.replace('text-darkGray', 'text-orange');
            item.querySelector('.collapsable-arrow').classList.replace('text-darkGray', 'text-orange');

            if(scroll) {
                //Scroll to active item
                const itemPosition = item.getBoundingClientRect().top;
                const bodyPosition = document.body.getBoundingClientRect().top;
                const offsetPosition = itemPosition - bodyPosition;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }

        } else {
            item.querySelector('.collapsable-description').classList.replace('animate-dropdown-out', 'animate-dropdown-in');
            setTimeout(() => {
                item.querySelector('.collapsable-description').classList.add('hidden');
                item.querySelector('.collapsable-arrow').classList.remove('rotate-180');
                item.querySelector('.collapsable-title h4').classList.replace('text-orange', 'text-darkGray');
                item.querySelector('.collapsable-arrow').classList.replace('text-orange', 'text-darkGray');
            }, 300);
        }
    }

    closeAllDropdowns() {
        const { collapsableContent, collapsableArrows, collapsableTitle } = this.collapsableComponents();
        collapsableContent.forEach(item => {
            item.classList.add('hidden');
        });
        collapsableArrows.forEach(arrow => {
            arrow.classList.remove('rotate-180');
            arrow.classList.replace('text-orange', 'text-darkGray');
        })
        collapsableTitle.forEach(title => {
            title.classList.replace('text-orange', 'text-darkGray');
        });
    }

    collapsableComponents() {
        const collapsable = this.querySelectorAll('.collapsable');
        const collapsableContent = this.querySelectorAll('.collapsable-description');
        const collapsableArrows = this.querySelectorAll('.collapsable-arrow');
        const collapsableTitle = this.querySelectorAll('.collapsable-title h4');
        const openCollapsable = this.querySelectorAll('.open-collapsable');
        
        return { collapsable, openCollapsable, collapsableTitle, collapsableContent, collapsableArrows };
    }
}

customElements.define('collapsable-component', Collapsable);